// Components
import { Layout, Error, Spinner } from '@tracklib/kit'
import { YourLibraryHeader } from 'kit'
import SEO from 'components/base/seo'
import TrackList from 'components/browse/tracklist'
import CoverGrid from 'components/covergrid'
import Filter from 'components/filter'

// Hooks
import { useSearchQuery } from 'modules/browse/hooks'
import { useProfile } from 'modules/profile/hooks'
import { useRequest } from 'modules/requests/hooks'

//  Utils
import { isBrowser } from '@process'

const PurchasedTracks = () => {
  const title = 'Purchased Tracks'
  const description = 'All your purchased tracks.'
  const profile = useProfile()

  const fetchProfileRequest = useRequest('FETCH_PROFILE')

  const queryObj = { owned: true }
  const { trackIds, ...songListProps } = useSearchQuery(queryObj, profile?.purchased_tracks.length)
  if (profile.id === 0) {
    if (fetchProfileRequest.isDone && isBrowser) {
      return <Error />
    }
    return (
      <Layout.FullWidth>
        <SEO title={title} description={description} />
        <Spinner minHeight={400} delay={0} />
      </Layout.FullWidth>
    )
  }

  return (
    <>
      <SEO title={title} description={description} />
      <YourLibraryHeader title={title} description={description} image={<CoverGrid mask="disc" trackIds={trackIds} />} />
      <Layout.FullWidth>
        <Filter queryObj={queryObj} />
        <TrackList trackIds={trackIds} renderSpecificTrackNames {...songListProps} />
      </Layout.FullWidth>
    </>
  )
}

export default PurchasedTracks
